
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface SiteSettings {
  id?: string;
  logo_url: string;
  site_title: string;
  hero_title: string;
  hero_subtitle: string;
  hero_description: string;
  about_title: string;
  about_content: string;
  about_mission: string;
  about_vision: string;
  contact_phone: string;
  contact_email: string;
  contact_address: string;
  maintenance_mode: boolean;
  maintenance_message: string;
  maintenance_start_time: string | null;
  maintenance_end_time: string | null;
}

const defaultSettings: SiteSettings = {
  logo_url: '/lovable-uploads/b93b5bad-cffe-4247-aa30-5fa8a0d5cc9a.png',
  site_title: 'كنف العقارية',
  hero_title: 'ابحث عن منزل أحلامك',
  hero_subtitle: 'منصة كنف العقارية',
  hero_description: 'اكتشف أفضل العقارات في سلطنة عمان',
  about_title: 'عن كنف',
  about_content: 'منصة عقارية رائدة تهدف إلى تسهيل عملية البحث عن العقارات وربط الملاك بالباحثين عن السكن في سلطنة عمان.',
  about_mission: 'مهمتنا هي تسهيل عملية البحث عن العقارات وتوفير منصة آمنة وموثوقة للملاك والمستأجرين في سلطنة عمان.',
  about_vision: 'رؤيتنا أن نكون المنصة الأولى والأكثر ثقة للعقارات في سلطنة عمان.',
  contact_phone: '+968912345678',
  contact_email: 'info@kanf.om',
  contact_address: 'مسقط، سلطنة عمان',
  maintenance_mode: false,
  maintenance_message: 'الموقع تحت الصيانة، سنعود قريباً',
  maintenance_start_time: null,
  maintenance_end_time: null,
};

export const useSiteSettings = () => {
  const [settings, setSettings] = useState<SiteSettings>(defaultSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const { data, error } = await supabase
        .from('site_settings')
        .select('*')
        .single();
      
      if (error && error.code !== 'PGRST116') {
        console.error('Error loading settings:', error);
        setSettings(defaultSettings);
      } else if (data) {
        setSettings(data);
      } else {
        setSettings(defaultSettings);
      }
    } catch (error) {
      console.error('Error loading settings:', error);
      setSettings(defaultSettings);
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = () => {
    loadSettings();
  };

  return {
    settings,
    loading,
    refreshSettings
  };
};
